import {
  canAccessInstituteManagement,
  canAccessProgramAdminConsole,
  isProgramAdmin,
} from "@/lib/workspace-role"

/** Institute management for tenet admins; program admins see Program admin. */
export function adminConsoleLabel(): string {
  if (canAccessInstituteManagement()) return "Institute management"
  if (isProgramAdmin() && canAccessProgramAdminConsole()) return "Program admin"
  return "Administrator"
}
